var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.5H2M11 14.5H6M2 8.7L2 16.3C2 17.4201 2 17.9802 2.21799 18.408C2.40973 18.7843 2.71569 19.0903 3.09202 19.282C3.51984 19.5 4.07989 19.5 5.2 19.5L18.8 19.5C19.9201 19.5 20.4802 19.5 20.908 19.282C21.2843 19.0903 21.5903 18.7843 21.782 18.408C22 17.9802 22 17.4201 22 16.3V8.7C22 7.5799 22 7.01984 21.782 6.59202C21.5903 6.2157 21.2843 5.90974 20.908 5.71799C20.4802 5.5 19.9201 5.5 18.8 5.5L5.2 5.5C4.0799 5.5 3.51984 5.5 3.09202 5.71799C2.7157 5.90973 2.40973 6.21569 2.21799 6.59202C2 7.01984 2 7.57989 2 8.7Z",
    stroke: "#101E8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.4ff67ff55399f8c3cc569f975ffddb2f.svg";
export { ForwardRef as ReactComponent };